import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure:false
})
export class FilterPipe implements PipeTransform {

  transform(value: any, attr : string , check : string): any {

    return value.filter((val)=>{
      if(val[attr] === check){
        return val
      }
    })
    
  }

}
